import PageLayout from '@hellodarwin/app-core/lib/layouts/page-layout';
import useLocale from '@hellodarwin/core/lib/features/providers/locale-provider';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/index';
import ProjectSingle from '../../../components/projects/project-single';
import { ProjectSingleSections } from '../../../components/projects/project-single/project-single-section/sections';
import {
  fetchSingleProject,
  selectProjectById,
} from '../../../features/api/slices/projects-slice';
import { useNewClientApi } from '../../../features/api/use-client-api';

const ClientProjectPage = () => {
  const { t } = useTranslation();
  const { projectId } = useParams<{
    projectId: string;
  }>();
  const { selectedLocale } = useLocale();
  const api = useNewClientApi();
  const dispatch = useAppDispatch();

  const project = useAppSelector((state) =>
    selectProjectById(state, projectId ?? ''),
  );

  useEffect(() => {
    dispatch(
      fetchSingleProject({
        api,
        project_id: projectId ?? '',
        locale: selectedLocale,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  return (
    <PageLayout
      app="client"
      goBackTo={'/game-plan'}
      title={project?.title ?? ''}
      breadcrumbs={[
        {
          breadcrumbName: t('navigation.home'),
          path: '/',
        },
        {
          breadcrumbName: t('project|gamePlan'),
          path: '/game-plan',
        },
        {
          breadcrumbName: project?.title,
        },
      ]}
    >
      {!!project && (
        <ProjectSingle
          project={project}
          sections={[ProjectSingleSections.Applications]}
        />
      )}
    </PageLayout>
  );
};

export default ClientProjectPage;
